import * as React from 'react'
// import isomorphicCookie from 'isomorphic-cookie'

import PopupModal from '../../../../components/home/PopupModal/PopupModal'

// import dateFormat from '../../../../services/data/dateFormat'

// import * as ProfileApiServices from '../../../../services/api/requests/Profile'
import { setGAEvent } from '../../../../services/analytics/google-analytics'
import useWindowSize from '../../../../services/hooks/useWindowSize'

const phoneMaxWidth = 575.98

function MainView({
  accessToken,
  advanceAccount,
  displayProfileModal,
  setTransportationMall,
  setProfileModalPage,
  setProfileModalDetailPage,
  doGetPopupModal,
  doClose,
  doNavigate,
  push,
  location,
}) {
  const [
    width,
    // , height
  ] = useWindowSize()
  const [displayed, hasDisplayed] = React.useState(false)
  const [desktop, isDesktop] = React.useState(undefined)
  const [displayPopup, setDisplayPopup] = React.useState(false)
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const [popupData, setPopupData] = React.useState([])
  const [displayTime, setDisplayTime] = React.useState(null)
  const { data } = location || {}

  React.useEffect(() => {
    const { innerWidth } = window || {}
    if (innerWidth > phoneMaxWidth) isDesktop(true)
    else isDesktop(false)
  }, [width])

  React.useEffect(() => {
    doGetPopupModal({
      setPopupData,
      accessToken,
      advanceAccount,
      desktop,
      // accountType,
      // setCurrentIndex,
    })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [desktop, accessToken, doGetPopupModal])

  React.useEffect(() => {
    if (desktop !== undefined && popupData && !displayed) {
      const lastIndex = localStorage.getItem('popup-index')
      let nextIndex = lastIndex ? parseInt(lastIndex) + 1 : 0

      if (popupData.length > 0 && !popupData[nextIndex]) {
        nextIndex = 0
      }
      if (popupData && popupData[nextIndex]) {
        const { title } = popupData[nextIndex]
        setCurrentIndex(nextIndex)
        setGAEvent('popup_modal', 'view', title, 1)
        setDisplayTime(Date.now())
        setDisplayPopup(true)
        hasDisplayed(true)
        if (popupData[nextIndex + 1])
          localStorage.setItem('popup-index', nextIndex)
        else localStorage.removeItem('popup-index')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupData, desktop])

  const onClose = React.useCallback(() => {
    if (displayPopup && popupData[currentIndex]) {
      setGAEvent(
        'popup_modal',
        'view_duration',
        popupData[currentIndex].title,
        Date.now() - displayTime,
      )
    }
  }, [displayPopup, popupData, currentIndex, displayTime])

  React.useEffect(() => {
    window.addEventListener('beforeunload', onClose)

    return () => {
      window.removeEventListener('beforeunload', onClose)
    }
  }, [onClose])

  if (!(Boolean(popupData) && popupData[currentIndex] && displayPopup)) {
    return null
  }

  const {
    title,
    popupType,
    notificationId,
    deeplinkType,
    customDeeplinkUrl,
  } = popupData[currentIndex]

  return data && data.fromModal ? (
    <></>
  ) : (
    <PopupModal
      data={popupData[currentIndex]}
      show={displayPopup}
      onClose={doClose({
        title,
        currentIndex,
        onClose,
        setDisplayPopup,
        setCurrentIndex,
      })}
      onNavigate={doNavigate({
        title,
        popupType,
        deeplinkType,
        customDeeplinkUrl,
        notificationId,
        onClose,
        setDisplayPopup,
        accessToken,
        displayProfileModal,
        setTransportationMall,
        setProfileModalPage,
        setProfileModalDetailPage,
        push,
      })}
      desktop={desktop}
    />
  )
}

MainView.defaultProps = {}

MainView.propTypes = {}

export default MainView
